.container {
  width: 26px;
  height: 26px;
  background-color: #FFFFFF14;
  padding: 4px;
  border-radius: 50%;
  background-image: url(src/assets/images/currency.png);
  background-repeat: no-repeat;
  background-size: auto 18px;
  background-position: center;
}

.dark {
  background-image: url(src/assets/images/currency-dark.png);
}

.usd {
  background-image: url(src/assets/images/currency-usd.png);
}

.ton {
  background-image: url(src/assets/images/currency-ton.svg);
}

.usdt {
  background-image: url(src/assets/images/currency-usdt.svg);
}

.usdc {
  background-image: url(src/assets/images/currency-usdc.png);
}

/* Euro: the fiat sign for a EUR-priced car, and Circle's euro stablecoin for the amount that
   actually settles it. The stablecoin marks are the official ones, kept in the repository — the
   storefront loads no asset from a third-party host at runtime. */
.eur {
  background-image: url(src/assets/images/currency-eur.svg);
}

.eurc {
  background-image: url(src/assets/images/currency-eurc.png);
}
